import { fontSizes } from "../../../../constants/constants";
import dynamicfunction from "../../../../utils/dynamicfunction";
import CustomInput from '../../../../components/CustomInput';
import { ErrorText, InputField, RadioButton, RowView, Text } from "../index"
const NonReportingFiThen = ({
  getContent,
  values,
  setFieldValue,
  setFieldError,
  setFieldTouched,
  touched,
  optionsYesOrNO,
  errors,
}) => {
  const { TextWeight } = dynamicfunction();
  return (
    <div className='pt-3 sm:pt-5'>
      <Text
        text={getContent('if_non_reporting_fi_then')}
        size={fontSizes.h18}
        isTruncate={false}
        weight={TextWeight.medium}
        className='block'
        isRequired={true}
      />
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent(
              'are_you_non_reporting_financial_institution_under_crs'
            )}
            value={values?.nonReportingFinancialInstitutionUnderCrs}
            onChange={(e) => {
              setFieldValue('nonReportingFinancialInstitutionUnderCrs', e);
              setFieldTouched('nonReportingFinancialInstitutionUnderCrs', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.nonReportingFinancialInstitutionUnderCrs ? errors?.nonReportingFinancialInstitutionUnderCrs : '')}
          />
        </div>
      </RowView>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('governmental_entity')}
            value={
              values?.governmentalEntityForNonReportingFinancialInstitution
            }
            onChange={(e) => {
              setFieldValue(
                'governmentalEntityForNonReportingFinancialInstitution',
                e
              );
              setFieldTouched(
                'governmentalEntityForNonReportingFinancialInstitution',
                false
              );
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(
              touched?.governmentalEntityForNonReportingFinancialInstitution
                ? errors?.governmentalEntityForNonReportingFinancialInstitution
                : ''
            )}
          />
        </div>
        <div className='w-full'>
          <RadioButton
            label={getContent('international_organization')}
            value={
              values?.internationalOrganizationForNonReportingFinancialInstitution
            }
            onChange={(e) => {
              setFieldValue(
                'internationalOrganizationForNonReportingFinancialInstitution',
                e
              );
              setFieldTouched(
                'internationalOrganizationForNonReportingFinancialInstitution',
                false
              );
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(
              errors?.internationalOrganizationForNonReportingFinancialInstitution
            )}
          />
        </div>
        <div className='w-full'>
          <RadioButton
            label={getContent('central_bank')}
            value={values?.centralBankForNonReportingFinancialInstitution}
            onChange={(e) => {
              setFieldValue(
                'centralBankForNonReportingFinancialInstitution',
                e
              );
              setFieldTouched(
                'centralBankForNonReportingFinancialInstitution',
                false
              );
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(
              touched?.centralBankForNonReportingFinancialInstitution
                ? errors?.centralBankForNonReportingFinancialInstitution
                : ''
            )}
          />
        </div>
      </RowView>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('broad_participation_fund')}
            value={values?.boardParticipationRetirementFund}
            onChange={(e) => {
              setFieldValue('boardParticipationRetirementFund', e);
              setFieldTouched('boardParticipationRetirementFund', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.boardParticipationRetirementFund ? errors?.boardParticipationRetirementFund : '')}
          />
        </div>
        <div className='w-full'>
          <RadioButton
            label={getContent('narrow_participation')}
            value={values?.narrowParticipationRetirementFund}
            onChange={(e) => {
              setFieldValue('narrowParticipationRetirementFund', e);
              setFieldTouched('narrowParticipationRetirementFund', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.narrowParticipationRetirementFund ? errors?.narrowParticipationRetirementFund : '')}
          />
        </div>
        <div className='lg:w-full hidden lg:block'></div>
      </RowView>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('pension_fund')}
            value={values?.pensionFundOfGovtEntIntlOrgCentralBank}
            onChange={(e) => {
              setFieldValue('pensionFundOfGovtEntIntlOrgCentralBank', e);
              setFieldTouched('pensionFundOfGovtEntIntlOrgCentralBank', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.pensionFundOfGovtEntIntlOrgCentralBank ? errors?.pensionFundOfGovtEntIntlOrgCentralBank : '')}
          />
        </div>
      </RowView>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('exempt_collective_investment_vehicle')}
            value={values?.exemptCollectiveInvestmentVehicle}
            onChange={(e) => {
              setFieldValue('exemptCollectiveInvestmentVehicle', e);
              setFieldTouched('exemptCollectiveInvestmentVehicle', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.exemptCollectiveInvestmentVehicle ? errors?.exemptCollectiveInvestmentVehicle : '')}
          />
        </div>
      </RowView>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('trust_whose_trustees_report')}
            value={
              values?.trusteeReportsAllRequiredCRSInfoForReportableAccounts
            }
            onChange={(e) => {
              setFieldValue(
                'trusteeReportsAllRequiredCRSInfoForReportableAccounts',
                e
              );
              setFieldTouched(
                'trusteeReportsAllRequiredCRSInfoForReportableAccounts',
                false
              );
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(
              touched?.trusteeReportsAllRequiredCRSInfoForReportableAccounts
                ? errors?.trusteeReportsAllRequiredCRSInfoForReportableAccounts
                : ''
            )}
          />
        </div>
      </RowView>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('qualified_credit_card_issuer')}
            value={
              values?.qualifiedCreditCardIssuersForNonReportingFinancialInstitution
            }
            onChange={(e) => {
              setFieldValue(
                'qualifiedCreditCardIssuersForNonReportingFinancialInstitution',
                e
              );
              setFieldTouched(
                'qualifiedCreditCardIssuersForNonReportingFinancialInstitution',
                false
              );
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(
              touched?.qualifiedCreditCardIssuersForNonReportingFinancialInstitution
                ? errors?.qualifiedCreditCardIssuersForNonReportingFinancialInstitution
                : ''
            )}
          />
        </div>
        <div className='w-full'>
          <RadioButton
            label={getContent('other_entity')}
            value={values?.isOtherEntityLowRiskUnderDomesticLaw}
            onChange={(e) => {
              setFieldValue('isOtherEntityLowRiskUnderDomesticLaw', e);
              setFieldTouched('isOtherEntityLowRiskUnderDomesticLaw', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.isOtherEntityLowRiskUnderDomesticLaw ? errors?.isOtherEntityLowRiskUnderDomesticLaw : '')}
          />
        </div>
      </RowView>
      {Number(values?.isOtherEntityLowRiskUnderDomesticLaw) === 1 && (
        <RowView className='pt-3 sm:pt-5'>
          <CustomInput
                          isRounded
                          isRequired={true}
            label={getContent('specify_the_type_provided_in_domestic_law')}
            value={values?.specifyTypeProvidedInDomesticLaw}
            onChange={(e) => {
              setFieldValue('specifyTypeProvidedInDomesticLaw', e.target.value);
              setFieldTouched('specifyTypeProvidedInDomesticLaw', true, false);
            }}
            labelDivClass={"h-8 sm:h-6"}
            placeholder={getContent('enter_type')}
            errorMessage={getContent(touched?.specifyTypeProvidedInDomesticLaw ? errors?.specifyTypeProvidedInDomesticLaw : '')}
          />
        </RowView>
      )}
    </div>
  );
};
export default NonReportingFiThen;
